import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ChangeDetectorRef,
} from '@angular/core';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { ShowScrollAlert } from '../../state/engine.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { trigger, transition, style, animate, sequence } from '@angular/animations';

@Component({
  selector: 'app-engine-scroll',
  templateUrl: './engine-scroll.component.html',
  styleUrls: ['./engine-scroll.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('show', [
      transition(':enter', [
        sequence([
          style({
            opacity: '*',
          }),
          animate(
            '500ms ease-in-out',
            style({
              opacity: 1,
            }),
          ),
          animate(
            '500ms 2000ms ease-in-out',
            style({
              opacity: 0,
            }),
          ),
        ]),
      ]),
    ]),
  ],
})
export class EngineScrollComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();
  show = false;

  constructor(private actions: Actions, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.actions
      .pipe(ofActionDispatched(ShowScrollAlert), takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.show = true;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onShowDone() {
    this.show = false;
  }
}
